import gql from 'graphql-tag';
import createClient from '../../clientSetup';

export const RETIREMENT_DATE_FUNDS_QUERY = gql`
  {
    dateFunds(dateFundType: RETIREMENT_DATE_FUND) {
      shortName
      ticker
      trpCode
      cusip
      iClass
      targetYear
    }
  }
`;

export const mockedRDFFunds = [
  {
    shortName: 'Retirement 2010 Fund - I Class',
    ticker: 'TRPUX',
    trpCode: 'R4A',
    cusip: '872797311',
    iClass: true,
    targetYear: 2010
  },
  {
    shortName: 'Retirement 2020 Fund - I Class',
    ticker: 'TRDBX',
    trpCode: 'R4B',
    cusip: '872797287',
    iClass: true,
    targetYear: 2020
  },
  {
    shortName: 'Retirement 2030 Fund - I Class',
    ticker: 'TRFHX',
    trpCode: 'R4C',
    cusip: '872797261',
    iClass: true,
    targetYear: 2030
  },
  {
    shortName: 'Retirement 2040 Fund - I Class',
    ticker: 'TRHDX',
    trpCode: 'R4D',
    cusip: '872797246',
    iClass: true,
    targetYear: 2040
  },
  {
    shortName: 'Retirement 2015 Fund - I Class',
    ticker: 'TRUBX',
    trpCode: 'R4G',
    cusip: '872797295',
    iClass: true,
    targetYear: 2015
  },
  {
    shortName: 'Retirement 2025 Fund - I Class',
    ticker: 'TREHX',
    trpCode: 'R4H',
    cusip: '872797279',
    iClass: true,
    targetYear: 2025
  },
  {
    shortName: 'Retirement 2035 Fund - I Class',
    ticker: 'TRFJX',
    trpCode: 'R4I',
    cusip: '872797253',
    iClass: true,
    targetYear: 2035
  },
  {
    shortName: 'Retirement 2005 Fund - I Class',
    ticker: 'TRAJX',
    trpCode: 'R4J',
    cusip: '872797329',
    iClass: true,
    targetYear: 2005
  },
  {
    shortName: 'Retirement 2045 Fund - I Class',
    ticker: 'TRIKX',
    trpCode: 'R4K',
    cusip: '872797238',
    iClass: true,
    targetYear: 2045
  },
  {
    shortName: 'Retirement 2050 Fund - I Class',
    ticker: 'TRJLX',
    trpCode: 'R4L',
    cusip: '872797220',
    iClass: true,
    targetYear: 2050
  },
  {
    shortName: 'Retirement 2055 Fund - I Class',
    ticker: 'TRJMX',
    trpCode: 'R4M',
    cusip: '872797212',
    iClass: true,
    targetYear: 2055
  },
  {
    shortName: 'Retirement 2060 Fund - I Class',
    ticker: 'TRLNX',
    trpCode: 'R4N',
    cusip: '872797196',
    iClass: true,
    targetYear: 2060
  },
  {
    shortName: 'Retirement 2065 Fund - I Class',
    ticker: 'TRMOX',
    trpCode: 'R4O',
    cusip: '872797188',
    iClass: true,
    targetYear: 2065
  },
  {
    shortName: 'Retirement 2010 Fund',
    ticker: 'TRRAX',
    trpCode: 'RPA',
    cusip: '74149P101',
    iClass: false,
    targetYear: 2010
  },
  {
    shortName: 'Retirement 2020 Fund',
    ticker: 'TRRBX',
    trpCode: 'RPB',
    cusip: '74149P200',
    iClass: false,
    targetYear: 2020
  },
  {
    shortName: 'Retirement 2030 Fund',
    ticker: 'TRRCX',
    trpCode: 'RPC',
    cusip: '74149P309',
    iClass: false,
    targetYear: 2030
  },
  {
    shortName: 'Retirement 2040 Fund',
    ticker: 'TRRDX',
    trpCode: 'RPD',
    cusip: '74149P408',
    iClass: false,
    targetYear: 2040
  },
  {
    shortName: 'Retirement 2015 Fund',
    ticker: 'TRRGX',
    trpCode: 'RPG',
    cusip: '74149P796',
    iClass: false,
    targetYear: 2015
  },
  {
    shortName: 'Retirement 2025 Fund',
    ticker: 'TRRHX',
    trpCode: 'RPH',
    cusip: '74149P788',
    iClass: false,
    targetYear: 2025
  },
  {
    shortName: 'Retirement 2035 Fund',
    ticker: 'TRRJX',
    trpCode: 'RPI',
    cusip: '74149P770',
    iClass: false,
    targetYear: 2035
  },
  {
    shortName: 'Retirement 2005 Fund',
    ticker: 'TRRFX',
    trpCode: 'RPJ',
    cusip: '74149P812',
    iClass: false,
    targetYear: 2005
  },
  {
    shortName: 'Retirement 2045 Fund',
    ticker: 'TRRKX',
    trpCode: 'RPK',
    cusip: '74149P762',
    iClass: false,
    targetYear: 2045
  },
  {
    shortName: 'Retirement 2050 Fund',
    ticker: 'TRRMX',
    trpCode: 'RPL',
    cusip: '74149P754',
    iClass: false,
    targetYear: 2050
  },
  {
    shortName: 'Retirement 2060 Fund',
    ticker: 'TRRLX',
    trpCode: 'RPN',
    cusip: '74149P325',
    iClass: false,
    targetYear: 2060
  },
  {
    shortName: 'Retirement 2065 Fund',
    ticker: 'TRSJX',
    trpCode: 'RPO',
    cusip: '872797683',
    iClass: false,
    targetYear: 2065
  }
];

export const getRetirementDateFunds = async () => {
  const client = createClient();

  const {
    data: { dateFunds }
  } = await client.query({
    query: RETIREMENT_DATE_FUNDS_QUERY
  });
  return dateFunds;
};
